import { colors, Typography, TypographyProps } from '@ui-components/neo.tax';
import { ReactElement } from 'react';

type QreTableHeaderProps = {
  children: React.ReactNode;
  textAlign?: TypographyProps['textAlign'];
  title?: string;
};

export const TableHeader = ({ children, textAlign = 'left', title }: QreTableHeaderProps): ReactElement => (
  <Typography as="p" color={colors.gray[900]} fontWeight="medium" fontSize="sm" textAlign={textAlign} title={title}>
    {children}
  </Typography>
);
